import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { ITenderExchange } from 'src/common/interfaces/dtos/ITenderExchange';
import {
  ITenderExchangeDetails,
  ITenderExchangeState,
} from '../../interfaces/states/ITenderExchangeState';

const initialState: ITenderExchangeState = {
  tenderExchanges: [],
  isTenderExchange: false,
  tenderExchangeDetails: {},
};

class TenderExchangeReducer extends ImmerReducer<ITenderExchangeState> {
  public setTenderExchange(tenderExchanges: ITenderExchange[]): void {
    this.draftState = { ...this.draftState, tenderExchanges };
  }

  public setTenderExchangeState(state: boolean): void {
    this.draftState = { ...this.draftState, isTenderExchange: state };
  }

  public setTenderExchangeDetails(state: ITenderExchangeDetails): void {
    this.draftState = { ...this.draftState, tenderExchangeDetails: state };
  }

  public resetTenderExchangeDetails() {
    this.draftState = {
      ...this.draftState,
      tenderExchangeDetails: {
        paymentTender: undefined,
        refundTender: undefined,
        exchangeAmount: undefined,
        isRefundScreenVisible: false,
        isSingleTenderExchange: false,
      },
    };
  }

  public updateTenderExchangeDetails(state: ITenderExchangeDetails): void {
    this.draftState.tenderExchangeDetails = { ...this.draftState.tenderExchangeDetails, ...state };
  }
}

export const TenderExchangeActions = createActionCreators(TenderExchangeReducer);
export const TenderExchangeReducerFunction = createReducerFunction(
  TenderExchangeReducer,
  initialState,
);
